import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './MobileStopModal.module.scss'
import { Button } from 'blaze-ui/Button'
import { MobileStop, Props as MobileStopProps } from 'components/MobileStop/MobileStop'

type Props = Pick<MobileStopProps, 'variant'>

export const MobileStopModal = (props: Props) => {
  const { variant } = props
  const { closeModal } = useModals()

  const showCloseButton = variant === 'trial-ended' || variant === 'credits'

  return (
    <Modal.Root size="md" blaze>
      <Modal.Header className={Styles.header} preventClose>
        {showCloseButton && (
          <div className={Styles.left}>
            <Button variant="editor" size="lg" onPress={closeModal}>
              Close
            </Button>
          </div>
        )}
      </Modal.Header>
      <Modal.Content className={Styles.content}>
        <MobileStop onNavigate={closeModal} variant={variant} />
      </Modal.Content>
    </Modal.Root>
  )
}
